import { Chakra } from "@airhelp/react-ui-components";
import { useTranslations, useLocalizedData } from "contexts/LocalizationContext/hooks";
import Grid from "modules/common/components/Grid";
import { useReferralProgramConfig } from "contexts/DataContext/hooks";
import config from "config/config";
import Modal from "modules/help-a-friend/components/Modal";
import { useModal } from "contexts/ModalContext";
import { trackEvents } from "utils/trackingUtils";
import { SHARE_NOW_CUSTOMERS_SAY_GTM, SHARE_NOW_CUSTOMERS_SAY_MP } from "modules/help-a-friend/trackingConsts";
import CardsContainer from "components/CardsContainer";
import { HOW_IT_WORKS_ITEMS, HOW_IT_WORKS_ANCHOR } from "../../consts";

const { Box, Flex, Text, Heading, Button } = Chakra;

const HowItWorks = () => {
  const translations = useTranslations();
  const { getLocalizedCurrency, getCompensationValue } = useLocalizedData();
  const { openModal } = useModal();
  const referralProgramConfig = useReferralProgramConfig();
  const { commissionValue } = referralProgramConfig;
  const localizedCommissionValue = getLocalizedCurrency(commissionValue, "EUR");

  const translationVariables = {
    "%compensation%": getCompensationValue(),
    "%luggage-compensation%": getCompensationValue("luggage"),
    "%extra-expenses%": getCompensationValue("extraExpenses"),
    "%commission%": localizedCommissionValue,
  };

  const translatedCards = HOW_IT_WORKS_ITEMS.map((item) => ({
    ...item,
    heading: translations(item.heading),
    text: translations(item.text, translationVariables),
  }));

  const clickHandler = () => {
    openModal(<Modal />, "md");
    trackEvents({ gtmEvent: SHARE_NOW_CUSTOMERS_SAY_GTM, mixpanelEvent: SHARE_NOW_CUSTOMERS_SAY_MP });
  };

  return (
    <Box
      bgColor="greyscale.300"
      bgRepeat="no-repeat"
      bgImage={{
        base: "none",
        lg: `url(${config.staticUrl}/i/airhelp-plus/ahplus-landing-page-bg-fragment-triangles-01.svg)`,
      }}
      py={{ base: 14, lg: 28 }}
      bgPosition="left -30%"
    >
      <Grid id={HOW_IT_WORKS_ANCHOR} mb={0}>
        <Flex gridColumn={{ base: "span 1", md: "span 12" }} flexDir="column">
          <Text color="primary.500" fontSize="sm" textTransform="uppercase" fontWeight="bold" pb={2}>
            {translations("how_it_works")}
          </Text>
          <Flex direction={{ base: "column", xl: "row" }} flexWrap="wrap">
            <Heading variant="h2" as="h2" pb={2}>
              {translations("how_it_works_it_is_easy", { "%commission%": localizedCommissionValue })}
            </Heading>
            <Button
              p={0}
              bg="transparent"
              _hover={{ bg: "transperent" }}
              variant="subtle"
              alignSelf={{ base: "flex-start", xl: "flex-end" }}
              fontSize="lg"
              mb={{ base: 10, xl: 14 }}
              ml={{ base: 0, xl: "auto" }}
              onClick={clickHandler}
              fontWeight="normal"
            >
              {translations("button_share_now")} &rarr;
            </Button>
          </Flex>
          <CardsContainer cards={translatedCards} cardsHeightDesktop="330" />
        </Flex>
      </Grid>
    </Box>
  );
};

export default HowItWorks;
